<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: meta.info.type,
                        href: meta.links.index,
                    },
                    {
                        name: requestable.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.message')" for="message" />
                        <FormTextarea
                            rows="3"
                            id="message"
                            v-model="form.message"
                            name="message"
                            type="text"
                            class="mt-1 w-full"
                            style="min-height: 60px"
                        />
                        <FormError :value="form.errors.message" class="mt-2" />
                    </div>
                    <div class="mt-1" v-show="meta.can.canModifyRewardPercent">
                        <label for="percent" class="block">
                            {{ $t('messages.percent_of_reward_requested') }}: <span>{{ form.percent }}%</span>
                        </label>
                        <input type="range" id="percent" name="percent" min="1" max="100" v-model="form.percent" />
                        <FormError :value="form.errors.percent" class="mt-2" />
                    </div>
                    <div class="mt-1">
                        <div class="flex justify-end space-x-2">
                            <SubmitFormButton :button-text="$t('messages.request')" :processing="form.processing" />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        PanelPage,
        FormLabel,
        FormTextarea,
        FormError,
        SubmitFormButton,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'requestable'],
    data() {
        return {
            form: this.$inertia.form({
                message: '',
                percent: 100,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
